import { render, staticRenderFns } from "./GoodsPackage.vue?vue&type=template&id=11310dc8&"
import script from "./GoodsPackage.vue?vue&type=script&lang=js&"
export * from "./GoodsPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports